// extracted by mini-css-extract-plugin
export default {"slideControls":"SectionsSwitch_slideControls","button":"SectionsSwitch_button","buttonSelected":"SectionsSwitch_buttonSelected"};